module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Da-Gb-Ha-Ia.ef51d6eb.png";